template(lang="pug")
  .kt-meeting

    // KPI Row
    .kpi-row
      .meeting-dashboard.d_flex
        h2 Meetings:
      .meeting-dashboard.d_flex
        .d_flex.meeting-card.today
          span.meeting-label Due Today:
          span.meeting-value {{ d_dueToday || "None" }}
        .d_flex.meeting-card.this-week
          span.meeting-label Due this week:
          span.meeting-value {{ d_dueThisWeek || "None" }}

    // Meeting Section
    .meeting-section
      .meeting-header
        .meeting-title
          span Meeting Board
          fa-icon(icon="chevron-down" class="title-chevron")

        .meeting-actions
          b-dropdown(
            variant="none"
            size="sm"
            right
            boundary="window"
            :class="['btn-filter-dd', { active: c_filterActive }]"
          )
            template(v-slot:button-content)
              fa-icon(icon="filter")
              span.filter-count(v-if="c_filterActive") {{ c_filterCount }}

            .meeting-filter-menu(@click.stop)
              .filter-field
                label Search
                b-form-input(
                  v-model="d_filterText"
                  size="sm"
                  placeholder="Name, company, stage..."
                  debounce="200"
                )

              .filter-field
                .filter-status-hdr
                  label Status
                  span.btn.btn-link.btn-sm(@click="m_selectAllStatuses") All
                  span.btn.btn-link.btn-sm(@click="m_clearStatuses") None

                b-form-checkbox-group(
                  v-model="d_filterStatuses"
                  stacked
                  class="filter-statuses"
                )
                  b-form-checkbox(
                    v-for="col in d_meetingAllStatues"
                    :key="col.key"
                    :value="col.key"
                  ) {{ col.label }}

      // Meeting Board
      .meeting-board(v-show="!d_meetingCollapsed")
        .meeting-empty(v-if="d_meetingColumns.length === 0") No Meeting Status selected

        .meeting-column(
          v-for="col in c_visibleMeetingColumns"
          :key="col.key"
        )
          .column-header(:style="{ borderTopColor: col.color }")
            span {{ col.label }}
            span.column-count ({{ col.count }})

          .column-cards
            draggable(
              :list="col.meetings"
              group="meeting"
              :animation="150"
              ghost-class="meeting-ghost"
              drag-class="meeting-drag"
              class="column-drag-list"
              @start="m_dragStart"
              @end="m_dragEnd"
              @change="m_changeStatus($event, col)"
            )
              .meeting-card(
                v-for="meeting in col.meetings"
                :key="meeting.meetingId"
                @click="m_openMeeting(meeting)"
              )
                .meeting-title {{ meeting.meetingSubject }}

                .meeting-meta
                  span(v-if="meeting.meetingDate")
                    | {{ meeting.status }} • When:
                    b.meeting-due-date {{ meeting.meetingDate }}:{{ meeting.meetingTime }}

                .meeting-avatars
                  .meeting-avatar(
                    v-for="(av, aix) in meeting.avatars"
                    :key="aix"
                    :style="{ backgroundColor: av.avatarColor }"
                    :title="av.name"
                  ) {{ av.initials }}

            .column-empty(v-if="m_colCount(col) === 0") No matching Meetings

          b-button.btn.btn-link.btn-sm(
            v-if="col.key === 'Scheduled'"
            @click="m_addNewMeeting"
          )
            fa-icon(icon="plus")
            |  Add Meeting

    // ⭐ Modal Meeting Editor
    b-modal(
      id="meetingModal"
      v-model="d_showMeeting"
      size="lg"
      centered
      hide-footer
      title="Meeting Record"
      @hidden="m_closeMeeting"
    )
      meeting-rec(
        :p_meeting="d_meeting"
        p_mode="modal"
        @save="m_saveMeeting"
        @cancel="m_closeMeeting"
        @delete="m_deleteMeeting"
      )

<script>
import draggable from "vuedraggable";
import util,{fn_checkPageEnabled} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import {fn_getMeetings,fn_saveMeeting, fn_updateMeetingColumn,fn_deleteRecord} from "@/utils/api.js";
import MeetingRec from "@/components/Rec/MeetingRec.vue";
export default {
	name: "kt-meeting",
	components: {
		draggable,
		"meeting-rec": MeetingRec,
	},
	created() {
	fn_getMeetings().then(resp => {

    const safeResp = resp || {};

    this.d_dueToday     = safeResp.dueToday     ?? 0;
    this.d_dueThisWeek  = safeResp.dueThisWeek  ?? 0;

    const rawMeetings = Array.isArray(safeResp.meetings)
        ? safeResp.meetings
        : [];

    this.d_meetings = rawMeetings.map(m => {
        const mtg = m || {};

        return {
            ...mtg,
            id: mtg.meetingId ?? null,
            avatars: fn_attendeeAvatars(mtg.attendees ?? [])
        };
    });

    this.d_meetingColumns = fn_buildMeetingColumns(
        this.d_meetings,
        this.d_allMeetingStatues ?? []
    ) || [];
   });
		
	},	   
	mounted() {},
	beforeDestroy() {
	},
	data() {
		return {
			d_meetingChart: null,
			d_marketSegmentChart: null,
			d_dragging: false,
			d_filterText: "",
			d_filterStatuses:null,
			d_meetingColumns:[],
			d_meetings: [],
			d_meeting:{},
			d_showMeeting:false,
			d_meetingCollapsed: false,
			d_allMeetingStatues:[
					{ key: "Scheduled", label: "Scheduled", color: "#4fa4ff" },
					{ key: "In Progress", label: "In Progress", color: "#f5a623" },
					{ key: "Completed", label: "Completed", color: "#9b59b6" },
					{ key: "Cancelled", label: "Cancelled", color: "#41b8d5" },
					{ key: "No Show", label: "No Show",color: "#27ae60" },
					],
			d_dueToday:null,
			d_dueThisWeek:null,
					 
		};
	},
    watch: {},
	computed: {
		c_visibleMeetingColumns() {
			const statuses = this.d_filterStatuses || [];
			return this.d_meetingColumns.filter(col => statuses.includes(col.key));
		},
		c_filterActive() {
			const allStatuses = this.d_meetingColumns?.length;
			return !!(this.d_filterText || "").trim() || this.d_filterStatuses?.length !== allStatuses;
		},
		c_filterCount() {
			return (this.d_filterStatuses || []).length;
		},
		c_checkMeeting(){return fn_checkPageEnabled('Home','Meeting');},
	},
	methods: {
		m_dragStart(e) {	
			this.d_dragging = true;
		},
		m_dragEnd(e) {
		    console.log('draggable event data',e);
			this.d_meetingColumns.forEach(col => {
				(col.meetings || []).forEach(m => {
					m.status = col.label;
				});
			});
		},
		m_changeStatus(e,col){
			if (e.added) {
			    console.log('e',e);
				console.log('col',col);
				const meetingId = e.added.element.id;
				const status = col.label;
				fn_updateMeetingColumn({meetingId, columnName:'status',columnValue:status});
			}
		},
        m_openMeeting(meeting) {
           this.d_meeting = { ...meeting };   
           this.d_showMeeting = true;            
        },
	    m_saveMeeting(){
		  fn_saveMeeting(this.d_meeting);
	    },
        m_closeMeeting() {
            this.d_showMeeting = false;
            this.d_meeting = null;
        },	  
        m_deleteMeeting() {
		    fn_deleteRecord('meeting',this.d_meeting.meetingId);
            this.d_showMeeting = false;
            this.d_meeting = null;
        },
        m_addNewMeeting() {
		  const now = new Date();
		  let minutes = now.getMinutes();
          let roundedMinutes = minutes < 15 ? 0 : minutes < 45 ? 30 : 0;
          let hour = now.getHours();
          if (minutes >= 45) {
             hour = (hour + 1) % 24;
          }
		  
          this.d_meeting = {
             meetingId: null,
             meetingTitle: "",
             meetingSummary: "",
             meetingDate: now.toISOString().slice(0, 10),
             meetingTime: `${String(hour).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}`,
             status: "Scheduled",
             attendees:{externalAttendees: [],internalAttendees: []},
             tags: []
         };
            this.d_showMeeting = true;
      },
      m_selectAllStatuses() {
			this.d_filterStatuses = this.d_allMeetingStatues.map(col => col.key);
		},
		m_clearStages() {
			this.d_filterStatuses = [];
		},  
	},
};
function fn_attendeeAvatars(attendees) {
    const AVATAR_COLORS=["#4fa4ff", "#41b8d5", "#9b59b6", "#f5a623", "#27ae60", "#e74c3c", "#1e8449", "#7f77dd",
                       '#33adff','#2d8bba','#2f5f98','#31356e','#4076ba','#41b8d5','#6ce5e8','#004f98'];
	const people = [];
	const internalSeen = new Set();
	const externalSeen = new Set();

	(internalAttendees || []).forEach(a => {
		const id = a.teamMemberId;
		if (id && internalSeen.has(id)) return;
		if (id) internalSeen.add(id);
		people.push({teamMemberId: m.teamMemberId,
				     name: m.teamMemberName,
					 email:m.email,
					 externalContactId: null,
			        });
	});
	
	(externalAttendees || []).forEach(a => {
		const id = a.externalContactId;
		if (id && externalSeen.has(id)) return;
		if (id) externalSeen.add(id);
		people.push({externalContactId: m.externalContactId,
				     name: m.externalName,
					 email:m.email,
					 teamMemberId: null
			        });
	});	
	

	if (!people.length) {
		return [{
		    externalContactId: null,
			teamMemberId: null,
			initials: "??",
			avatarColor: AVATAR_COLORS[0],
			name: "",
		}];
	}

	return people.map((m, ix) => ({
	    externalContactId: m.externalContactId,
		teamMemberId: m.teamMemberId,
		initials: m.name.split(/\s+/).map(w => w[0]).join("").slice(0, 2).toUpperCase(),
		avatarColor: AVATAR_COLORS[ix % AVATAR_COLORS.length],
		name: m.name || "",
	}));
	
}
function fn_buildMeetingColumns(allMeetings, statuses) {

	return statuses.map(s => {
		const meetings = allMeetings.filter(m => m.status == s);
		return {
			key: s.key,
			label: s.key,
			color: s.color,
			count: meetings.length,
			meetings,
		};
	});
}
</script>

<style scoped lang="less">
.kt-meeting {
	width: 100%;
	padding1: 0.5em 0.75em;
	text-align: left;

	.kpi-row {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 0.75em;
		margin-bottom: 1em;

		@media (max-width: 992px) {
			grid-template-columns: repeat(2, 1fr);
		}
		@media (max-width: 576px) {
			grid-template-columns: 1fr;
		}
	}

	.kpi-card {
		display: flex;
		align-items: flex-start;
		gap: 0.75em;
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

		.kpi-icon {
			width: 40px;
			height: 40px;
			border-radius: 0.5em;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			color: #fff;
			font-size: 1em;
		}

		.kpi-label {
			font-size: 0.8em;
			color: #6c757d;
			margin-bottom: 0.25em;
		}

		.kpi-value {
			font-size: 1.35em;
			font-weight: 700;
			color: #212529;
			line-height: 1.2;
		}

		.kpi-trend {
			font-size: 0.75em;
			color: #27ae60;
			margin-top: 0.35em;

			svg {
				margin-right: 0.25em;
			}
		}
	}

	.meeting-section {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 0.75em 1em 1em;
		margin-bottom: 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: visible;

		&.collapsed {
			padding-bottom: 0.75em;

			.meeting-header {
				margin-bottom: 0;
			}

			.title-chevron {
				transform: rotate(-90deg);
			}
		}
	}

	.meeting-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.75em;
		flex-wrap: wrap;
		gap: 0.5em;
	}

	.meeting-subject {
		font-size: 1.1em;
		font-weight: 600;
		color: #212529;
		cursor: pointer;
		user-select: none;
		display: flex;
		align-items: center;

		.title-chevron {
			font-size: 0.65em;
			margin-left: 0.4em;
			color: #6c757d;
			transition: transform 0.2s ease;
		}
	}

	.meeting-actions {
		display: flex;
		gap: 0.5em;
		align-items: center;

		.btn-filter-dd {
			.dropdown-toggle {
				display: inline-flex;
				align-items: center;
				gap: 0.35em;
				font-size: 0.85em;
				border:none;
			}

			&.active .dropdown-toggle {
				border-color: #4fa4ff;
				color: #4fa4ff;
			}

			/deep/ .dropdown-menu {
				z-index: 3000;
			}

			.filter-count {
				background: #4fa4ff;
				color: #fff;
				border-radius: 999px;
				font-size: 0.7em;
				min-width: 1.2em;
				padding: 0 0.35em;
				line-height: 1.4;
				text-align: center;
			}
		}
	}

	.meeting-filter-menu {
		min-width: 240px;
		padding: 0.6em 0.75em;
		text-align: left;

		.filter-field {
			margin-bottom: 0.75em;

			label {
				display: block;
				font-size: 0.75em;
				font-weight: 600;
				color: #6c757d;
				margin-bottom: 0.25em;
			}
		}

		.filter-stages-hdr {
			display: flex;
			align-items: center;
			gap: 0.25em;
			margin-bottom: 0.25em;

			label {
				margin: 0;
				margin-right: auto;
			}

			.btn-link {
				padding: 0;
				font-size: 0.75em;
			}
		}

		.filter-stages {
			max-height: 180px;
			overflow-y: auto;
			font-size: 0.85em;
		}

		.filter-footer {
			display: flex;
			justify-content: flex-end;
			border-top: 1px solid #e9ecef;
			padding-top: 0.5em;
		}
	}

	.meeting-empty,
	.column-empty {
		padding: 0.75em 0.4em;
		text-align: center;
		font-size: 0.78em;
		color: #868e96;
	}

	.meeting-board {
		display: flex;
		gap: 0.6em;
		overflow-x: auto;
		padding-bottom: 0.5em;

		&::-webkit-scrollbar {
			height: 0.4em;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #ced4da;
			border-radius: 0.4em;
		}
	}

	.meeting-column {
		flex: 0 0 210px;
		min-width: 210px;
		background: #f8f9fa;
		border-radius: 0.4em;
		display: flex;
		flex-direction: column;
	}

	.column-header {
		padding: 0.5em 0.6em;
		border-top: 3px solid;
		font-size: 0.85em;
		font-weight: 600;
		display: flex;
		flex-direction: column;
		gap: 0.15em;

		.column-total {
			font-size: 0.8em;
			font-weight: 400;
			color: #6c757d;
		}
	}

	.column-cards {
		padding: 0 0.4em 0.4em;
		flex: 1;
		overflow-y: auto;
		max-height: 280px;
		display: flex;
		flex-direction: column;
	}

	.column-drag-list {
		min-height: 40px;
		flex: 1;
	}

	.meeting-card {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.35em;
		padding: 0.55em 0.6em;
		margin-bottom: 0.5em;
		position: relative;
		cursor: grab;
		transition: box-shadow 0.15s;

		&:hover {
			box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		}

		&:active {
			cursor: grabbing;
		}

		&.won {
			border-color: #a9dfbf;
		}

		&.meeting-ghost {
			opacity: 0.4;
			border: 1px dashed #4fa4ff;
		}

		&.meeting-drag {
			opacity: 0.95;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
			cursor: grabbing;
		}

		.meeting-subject {
			font-size: 0.82em;
			font-weight: 600;
			color: #212529;
			padding-right: 1.8em;
			line-height: 1.3;
		}

		.meeting-value {
			font-size: 0.78em;
			color: #495057;
			margin-top: 0.2em;
		}
		.meeting-meta {
			font-size: 0.68em;
			color: #adb5bd;
			margin-top: 0.35em;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.meeting-due-date {
				color: #000;
				font-weight: 700;
			}
		}

		.meeting-avatars {
			position: absolute;
			top: 0.5em;
			right: 0.5em;
			display: flex;
			flex-direction: row-reverse;
		}

		.meeting-avatar {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			color: #fff;
			font-size: 0.55em;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1.5px solid #fff;
			margin-left: -6px;

			&:last-child {
				margin-left: 0;
			}
		}
	}

	.add-meeting {
		text-align: center;
		padding: 0.4em;
		font-size: 0.78em;
		color: #4fa4ff;
		cursor: pointer;

		svg {
			margin-right: 0.25em;
		}

		&:hover {
			text-decoration: underline;
		}
	}

	.bottom-row {
		display: grid;
		grid-template-columns: 2fr 1.2fr;
		gap: 0.75em;
		margin-bottom: 0;

		@media (max-width: 768px) {
			grid-template-columns: 1fr;
		}
	}

	.meeting-widget {
		width: 100%;
	}

	.widget {
		background: #fff;
		border: 1px solid #e9ecef;
		border-radius: 0.5em;
		padding: 0.75em 1em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: visible;
	}

	.widget-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 600;
		font-size: 0.95em;
		margin-bottom: 0.5em;
		color: #212529;

		.btn-filter-dd {
			.dropdown-toggle {
				display: inline-flex;
				align-items: center;
				gap: 0.35em;
				font-size: 0.85em;
				border: none;
				padding: 0.15em 0.4em;
			}

			&.active .dropdown-toggle {
				color: #4fa4ff;
			}

			/deep/ .dropdown-menu {
				z-index: 3000;
			}

			.filter-count {
				background: #4fa4ff;
				color: #fff;
				border-radius: 999px;
				font-size: 0.7em;
				min-width: 1.2em;
				padding: 0 0.35em;
				line-height: 1.4;
				text-align: center;
				font-weight: 600;
			}
		}

		.period-select {
			width: auto;
			font-size: 0.8em;
			font-weight: 400;
			border1: 1px solid #dee2e6;
			border-radius1: 0.25em;
            border: none;
		}

		.view-all {
			font-size: 0.85em;
			font-weight: 400;
			color: #4fa4ff;
			cursor: pointer;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	.chart-wrap {
		height: 300px;
		position: relative;
	}

	.donut-wrap {
		height: 140px;
		position: relative;
		margin-bottom: 0.5em;
	}

	.source-legend {
		.legend-item {
			display: flex;
			align-items: center;
			gap: 0.4em;
			font-size: 0.78em;
			padding: 0.2em 0;
			color: #495057;

			.legend-dot {
				width: 10px;
				height: 10px;
				border-radius: 50%;
				flex-shrink: 0;
			}

			.legend-pct {
				margin-left: auto;
				font-weight: 600;
			}
		}
	}

	.task-list {
		max-height: 220px;
		overflow-y: auto;
	}

	.task-empty {
		padding: 1em 0;
		text-align: center;
		font-size: 0.85em;
		color: #868e96;
	}

	.task-item {
		display: flex;
		align-items: center;
		gap: 0.6em;
		padding: 0.45em 0;
		border-bottom: 1px solid #f0f0f0;
		font-size: 0.82em;
		cursor: pointer;
		border-radius: 0.25em;
		transition: background-color 0.12s;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background-color: #f8f9fa;
		}
	}

	.task-check {
		width: 18px;
		height: 18px;
		border: 2px solid #dee2e6;
		border-radius: 50%;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.65em;
		color: #fff;

		&.done {
			background-color: #4fa4ff;
			border-color: #4fa4ff;
		}
	}

	.task-text {
		flex: 1;
		color: #212529;
		line-height: 1.3;
	}

	.task-date {
		font-size: 0.85em;
		color: #6c757d;
		flex-shrink: 0;

		&.overdue {
			color: #e74c3c;
		}
	}
}
/* Remove default BootstrapVue dropdown styling */
.export-trigger + .dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}

/* Remove extra padding Bootstrap adds */
::v-deep .export-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  padding: 6px 0 !important;
  background: #fff !important;
  min-width: 200px;
}
::v-deep .dropdown-menu {
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important; /* light shadow */
  padding: 6px 0 !important;
  background: white !important;
  min-width: 200px !important;
}
btn-clear{
	border:none;
	width:20px;
	height:20px;
}
button:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
.meeting-dashboard1 {
  display: flex;
  gap: 16px;
}

.meeting-card1 {
  flex: 1;
  padding: 16px;
  border-radius: 10px;
  background: #f8f9fa;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  text-align: center;
}

.task-count {
  font-size: 32px;
  font-weight: 700;
  color: #007bff;
}
.meeting-dashboard {
  display: flex;
  flex-direction1: column;
  gap: 12px;
  margin-top1: 12px;
}

.meeting-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding1: 14px 18px;
  background1: #ffffff;
  background: #e9f3ff; /* very light blue */
  border-radius1: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease;
  width:15%
}

.meeting-card:hover {
  background: #dcecff;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  
}

.meeting-label {
  font-size: 14px;
  color1: #6c757d;
   color: #2f3b52; /* darker muted text */
}

.meeting-value {
  font-size: 20px;
  font-weight: 700;
  color1: #007bff;
  color: #1a3d7c; /* darker blue */
}
.meeting-card.today {
  background: #fff3b0;        /* stronger yellow */
  border1: 1px solid #e6c96a;
  border:none;
  color: #3f320a;
}
.meeting-card.this-week {
  background: #fff9d6;        /* softer variant */
  border1: 1px solid #e8d9a3;
  border:none;
  color: #4a3f1a;
}
h2 {
  font-size: 1.3rem;   /* slightly smaller */
  font-weight: 600;
}

</style>
